import { render } from "./portfolioCustomerChart.vue?vue&type=template&id=338c3e1a"
import script from "./portfolioCustomerChart.vue?vue&type=script&lang=js"
export * from "./portfolioCustomerChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__